module.exports = __webpack_public_path__ + "img/icon-happy-staff@2x.d080b7b3.png";